import React, { useEffect } from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import 'react-quill/dist/quill.snow.css';
import './scss/styles.scss';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Catalog from './pages/Catalog';
import TitleWrapper from './pages/title/Wrapper';
import Account from './pages/Account';
import ChangePassword from './pages/account/ChangePassword';
import Users from './pages/Users';
import UserAdd from './pages/UserAdd';
import UserEdit from './pages/UserEdit';
import Providers from './pages/Providers';
import ProvidersAdd from './pages/ProvidersAdd';
import ProviderEdit from './pages/ProviderEdit';
import Styleguide from './pages/Styleguide';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ErrorPage404 from './pages/404';
import SalesAnalytics from './pages/sales/Analytics';
import SalesReports from './pages/sales/Reports';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PrivateRoute from './components/nav/PrivateRoute';
import usePageLoad from './hooks/usePageLoad';
import { sessionLoginFailure, sessionLoginStart, sessionLoginSuccess } from './slices/sessionSlice';
import { loadAccount } from './slices/sessionSlice';
import useDisabledLinks from './hooks/useDisabledLinks';

const App = () => {
    usePageLoad();
    const dispatch = useDispatch();
    useDisabledLinks();
    const { isAuthenticated, isLoading } = useSelector((state) => ({
        isAuthenticated: !!state.session.account,
        isLoading: state.session.loading
    }));

    useEffect(() => {
        dispatch(sessionLoginStart());
        loadAccount()
            .then((account) => {
                dispatch(sessionLoginSuccess(account));
            })
            .catch(() => dispatch(sessionLoginFailure()));
    }, [dispatch]);
    return (
        <Switch>
            <Route exact path="/logout">
                <Login />
            </Route>
            <Route exact path="/forgot-password">
                <ForgotPassword />
            </Route>
            <Route exact path="/reset-password">
                <ResetPassword />
            </Route>
            <Route exact path="/login">
                <Login />
            </Route>
            <Route exact path="/terms-of-use">
                <TermsOfUse />
            </Route>
            <Route exact path="/privacy-policy">
                <PrivacyPolicy />
            </Route>
            <Route exact path="/" render={({ location }) => (
                <Redirect to={{
                    pathname: "/home",
                    state: { from: location }
                }} />
            )} />
            <PrivateRoute exact path="/home" component={Home} />
            <PrivateRoute exact path="/account" component={Account} />
            <PrivateRoute exact path="/account/change-password" component={ChangePassword} />
            <PrivateRoute exact path="/catalog" component={Catalog} />
            <PrivateRoute exact path="/catalog/:catId/metadata" component={TitleWrapper} />
            <PrivateRoute exact path="/catalog/:catId/assets" component={TitleWrapper} />
            <PrivateRoute exact path="/catalog/:catId/submit" component={TitleWrapper} />
            <PrivateRoute exact path="/catalog/:catId/codes" component={TitleWrapper} />
            <PrivateRoute exact path="/reporting/sales" component={SalesAnalytics} />
            <PrivateRoute exact path="/reporting" component={SalesReports} />
            <PrivateRoute exact path="/users" component={Users} />
            <PrivateRoute exact path="/users/add" component={UserAdd} />
            <PrivateRoute exact path="/users/:username" component={UserEdit} />
            <PrivateRoute exact path="/providers" component={Providers} />
            <PrivateRoute exact path="/providers/add" component={ProvidersAdd} />
            <PrivateRoute exact path="/providers/:providerid" component={ProviderEdit} />
            <PrivateRoute exact path="/styleguide" component={Styleguide} />
            <Redirect from="/sales/reports" to="/reporting" />
            <Route>
                <ErrorPage404 />
            </Route>
        </Switch>
    );
};

export default App;
